import React from "react";
import { ShipBuilder } from "./components/ship-builder/ShipBuilder";
import { ModuleBuilder } from "./components/module-builder/ModuleBuilder";
import DebugPage from "./components/DebugPage";
import SettingsPage from "./components/SettingsPage";
import CoverPage from "./components/CoverPage";
import BugReportsAndSuggestions from "./components/BugReportsAndSuggestions";
import { AccessGate } from "./components/AccessGate";
import { ThemeProvider } from "./components/shared/ThemeProvider";
import { DarkModeIconToggle } from "./components/shared/DarkModeToggle";
import { UpdatesNotification } from "./components/common/UpdatesNotification";
import { BugsButton } from "./components/common/BugsButton";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

function App() {
  return (
    <Router>
      <AccessGate>
        <ThemeProvider>
          <div className="App">
          {/* Navigation - only show when not on cover page */}
          <Routes>
            <Route path="/" element={<CoverPage />} />
            <Route path="/*" element={
              <>
                <nav className="flex items-center gap-4 p-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 mb-4">
                  <Link to="/" className="font-bold text-lg text-gray-600 dark:text-gray-300 hover:underline">
                    Home
                  </Link>
                  <Link to="/ship-builder" className="font-bold text-lg text-highlightOrange hover:underline">
                    Ship Builder
                  </Link>
                  <Link to="/module-builder" className="font-bold text-lg text-purple-600 dark:text-purple-400 hover:underline">
                    Module Builder
                  </Link>
                  <div className="ml-auto flex gap-2 items-center">
                    <UpdatesNotification />
                    <BugsButton />
                    <DarkModeIconToggle />
                    <Link to="/feedback" className="px-3 py-1 rounded bg-green-600 dark:bg-green-700 text-white hover:bg-green-700 dark:hover:bg-green-600 transition">
                      🐛 Feedback
                    </Link>
                    <Link to="/settings" className="px-3 py-1 rounded bg-blue-600 dark:bg-blue-700 text-white hover:bg-blue-700 dark:hover:bg-blue-600 transition">
                      Settings
                    </Link>
                  </div>
                </nav>
                <Routes>
                  <Route path="/ship-builder" element={<ShipBuilder />} />
                  <Route path="/module-builder" element={<ModuleBuilder />} />
                  <Route path="/feedback" element={<BugReportsAndSuggestions />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/debug" element={<DebugPage />} />
                </Routes>
              </>
            } />
          </Routes>
          </div>
        </ThemeProvider>
      </AccessGate>
    </Router>
  );
}

export default App;
